const binding = { modules: {}, dataActions: {} };

    (binding.modules['terms-and-conditions-page'] = {
        c: () => require('partner/modules/terms-and-conditions-page/terms-and-conditions-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'terms-and-conditions-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/terms-and-conditions-page'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|terms-and-conditions-page|terms-and-conditions-page'] = {
                c: () => require('partner/modules/terms-and-conditions-page/terms-and-conditions-page.view.tsx'),
                cn: '__local__-__local__-terms-and-conditions-page'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };